// import auth from 'src/router/auth'
import PermissionDenied from '../PermissionDenied'
export default [
  {
    path: '/permission-denied',
    name: 'permission-denied',
    component: PermissionDenied
  }
]



// WEBPACK FOOTER //
// ./src/components/permissiondenied/routes/index.js